
   
    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                   style="background-image: url(../../assets/aboutusbanner.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 40px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Welcome To  WebSoulLabs</h1></div>
                        <div>
                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">
                                WebSoulLabs is a global software solutions provider in software
                                development, mobile application development, web designing, graphic
                                designing and digital marketing.
                                
                            </p>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="uk-section  uk-padding-small ">
        <div class="uk-container uk-container-large">
            <h2 class="uk-text-center" style="font-weight: 600px;">WIN THE FUTURE</h2>
            <p class="uk-text-justify uk-text-medium" style="font-size:18px">		
                Innovation drives the change of value creation. This revolution is challenging
                companies to continuously adapt their business model, organization and corporate
                culture in order to stay competitive. For a company to survive, the successful 
                exploitation of new ideas is crucial to be able to improve its processes, increase
                its efficiency, and bring new products and services to the market. More than 
                surviving the present, we must win the future. This will not be achieved with 
                a simple reduction of costs, but with a strategy of adding value through innovation
                and creativity. We bring in the right mix of technology and industry expertise to
                achieve your business needs. We help you reap better returns on your technology
                investment.
                



            </p>
                      
        </div>
    </div>
    
    <div class="uk-container">
        
        <h2 class="uk-text-center" style="margin-bottom: 0px; font-weight: 600px;"><span>HOW WE GET IT ?</span></h2>
        <br>
        <div class="uk-child-width-1-2@s uk-child-width-1-3@l uk-grid-match" uk-grid>
            <div class="uk-animation-toggle"  tabindex="0" >
                <div class="uk-card uk-card-default uk-card-body  uk-animation-scale-up  uk-margin-bottom">
                
                    <img class="uk-align-center" src="../../assets/cp.png" width="70" height="70" style="margin-bottom: 40px;" alt="pro mang">
                    <h4 class="uk-text-center uk-text-uppercase" style="font-weight: 600;">Consultation & Solution Architecture</h4>
                    <p class="uk-text-justify uk-text-medium" style=" color:#666;word-spacing: 1px;letter-spacing: -1px">We are here to provide 
                        world class services and functions  for your ides at challenging prices. Our team can understand our
                        clients goal and help them move ahead with their ideas come out with solutions to problems that ensure the success of our clients.</p>
                </div>
            </div>
        

            <div class="uk-animation-toggle"  tabindex="0" >
                <div class="uk-card uk-card-default uk-card-body  uk-animation-scale-up  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/te.png" width="70" height="70" alt="accounting">
                    <h4 class="uk-text-center uk-text-uppercase" style="font-weight: 600;">Technically Competent</h4>
                    <p class="uk-text-justify uk-text-medium " style="color:#666;word-spacing: 1px;letter-spacing: -1px">Our team at WebSoulLabs are fully committed
                         to our clients and believe in mutual growth with them. We guide you through every phase of business
                          development. We assure trending and updated technologies to flourish in business. We are specialised
                           in crafting innovative technologies.</p>
                </div>
            </div>


            <div class="uk-animation-toggle"  tabindex="0" >
                <div class="uk-card uk-card-default uk-card-body  uk-animation-scale-up  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/re.png" width="70" height="70" alt="tag">
                    <h4 class="uk-text-center uk-text-uppercase" style="font-weight: 600;">User Friendly Approach</h4>
                    <p class="uk-text-justify uk-text-medium" style="color:#666;word-spacing: 1px;letter-spacing: -1px">Technologies evolve swiftly and 
                        with it comes recent openings to expose your brand, services and products, and to delight new
                        and retain existing clients. Active brand care holds up to date with growths maintaining our clients at the leading edge in their distinct sectors that facilitate efficient management .</p>

            
                </div>
            </div>

            <div class="uk-animation-toggle"  tabindex="0" >
                <div class="uk-card uk-card-default uk-card-body  uk-animation-scale-up  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/code.png" width="70" height="70" alt="warehouse">
                    <h4 class="uk-text-center" style="font-weight: 600;">EFFICIENT CODING</h4>
                    <p class="uk-text-justify uk-text-medium" style="color:#666;word-spacing: 1px;letter-spacing: -1px">We have a squad of creators who are enthusiastic about logical excellent code and coding sessions. We admire the gravity of a verified core for your website and how wealth develop. With this in concept, our creators make assured the database configuration and architecture of websites is an upcoming testimonial.

                    </p>
                </div>
            </div>

            <div class="uk-animation-toggle"  tabindex="0" >
                <div class="uk-card uk-card-default uk-card-body  uk-animation-scale-up  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/growth.png" width="70" height="70" alt="product">
                    <h4 class="uk-text-center" style="font-weight: 600;">MUTUAL GROWTH AND DEVELOPMENT</h4>
                    <p class="uk-text-justify uk-text-medium" style="color:#666;word-spacing: 1px;letter-spacing: -1px">We always believe in growing together with our clients. Our priorities are always based on our customer satisfaction and mutual development. WebSoulLabs assure you the best and advanced solutions for your innovative ideas and business platforms.</p>
                </div>
            </div>

            <div class="uk-animation-toggle"  tabindex="0" >
                <div class="uk-card uk-card-default uk-card-body  uk-animation-scale-up  uk-margin-bottom">
                    <img class="uk-align-center" src="../../assets/crm.png" width="70" height="70" alt="invntr">
                    <h4 class="uk-text-center" style="font-weight: 600;">STRONG RELATIONSHIP</h4>
                    <p class="uk-text-justify  uk-text-medium" style=" color:#666;word-spacing: 1px;letter-spacing: -1px">We always maintains the healthy relationship with our  customers. Sustaining and developing is all about maintaining the core relationships with others. For us, the customers are over the prior consideration in all the  cases. WebSoulLabs is the best place where you can make your ideas come true.

                    </p>
                </div>
            </div>

        
        </div>
        

    </div>
    <div class="uk-section  uk-padding" style=" padding-bottom: 0px;">
        <div class="uk-container uk-container-large ">
            <h2 class="uk-text-center uk-text-uppercase" style=" font-weight: 600px; margin-bottom: 10px;">Expertise  In Wesoullabs</h2>
            <div class="uk-grid-match  uk-child-width-1-2@s uk-child-width-1-3@l   uk-text-center"style="padding-top: 20px; padding-bottom: 20px;" uk-grid>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px; background-color: #135796;">
                        
                        <div class="pa" style="margin-top:10px;">
                            <span class="text-white">
                            <img src="../../assets/web.svg"  width="50" height="50" alt="svg" style="padding-top: 10px; color: #666;" ></span>
                            <h3 class="uk-text-center" style=" margin-top: 0px;color: snow;">WEB & UI DESIGN</h3>
                            <p class="uk-text-justify uk-text-medium" style="color: snow; word-spacing: 1px;letter-spacing: -1px">We targets on implementing focused and vigorous strategies to deploy web pages with UI. Beyond developing a product we create the best user experience. The combination of technology and style offer endless solutions & capture audience.</p>
                        </div>
                        
                       
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px; background-color: #135796;">
                        <div class="pa1" style="margin-top:10px;">
                            <span class="text-white">
                            <img src="../../assets/websvg.svg"  width="50" height="50" alt="svg" style="padding-top: 15px"  ></span>
                            <h3 class="uk-text-center" style="margin-top: 0px;color: snow;">WEB DEVELOPMENT</h3>
                            <p class="uk-text-justify uk-text-medium" style="color: snow;word-spacing: 1px;letter-spacing: -1px">Our well established and expert designers provide high quality web designs and create amazing digital experience.We will be certainly the perfect choice for your web development companion as we have the best expertise in the domain technology. </p>
                       
                        </div>
                        
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px; background-color: #135796;">
                        <div class="pa2" style="margin-top:10px;">
                            <span class="text-white">
                            <img src="../../assets/mob.svg"  width="50" height="50" alt="svg" style="padding-top: 10px"></span>
                            <h3 class="uk-text-center" style="  margin-top: 0px; color: snow;">MOBILE DEVELOPMENT</h3>
                            <p class="uk-text-justify uk-text-medium" style="color: snow;word-spacing: 1px;letter-spacing: -1px">WebSoulLabs, is one of the leading company for developing innovative and sophisticated mobile applications that helps you to standout in your business regime and capture wider audience for business benefits. We have a vibrant team of professional app designers.</p>
                       
                        </div>
                        
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;background-color: #135796;">
                        <div class="pa2" style="margin-top:10px;">
                            <span class="text-white">
                            <img src="../../assets/sho.svg"  width="50" height="50" alt="svg" style="padding-top: 10px"></span>
                            <h3 class="uk-text-center" style="  margin-top: 0px; color: snow;">E-COMMERCE<br> PORTAL</h3>
                            <p class="uk-text-justify uk-text-medium" style="color: snow;word-spacing: -1px">WebSoulLabs provide e-commerce development services that can take your business to the hands of your customers. We develop flexible, robust and scalable e-commerce platform that help you to boost your business.

                            </p>
                       
                        </div>
                        
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;background-color: #135796;">
                        <div class="pa2" style="margin-top:10px;">
                            <span class="text-white">
                            <img src="../../assets/mon.svg"  width="50" height="50" alt="svg" style="padding-top: 10px"></span>
                            <h3 class="uk-text-center" style="  margin-top: 0px;color: snow;">ONLINE<br> MARKETING</h3>
                            <p class="uk-text-justify uk-text-medium" style="color: snow;word-spacing: 1px;letter-spacing: -1px">We are a leading online marketing company that offers wide range of services to steep rise your business. We have a vibrant team of digital marketers having creative ideas that propels your business to supreme gain of success.</p>
                       
                        </div>
                        
                    </div>
                </div>
                <div>
                    <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;background-color: #135796;">
                        <div class="pa2" style="margin-top:10px;">
                            <span class="text-white">
                            <img src="../../assets/support.svg"  width="50" height="50" alt="svg" style="padding-top: 10px"></span>
                            <h3 class="uk-text-center" style="  margin-top: 0px; color: snow;">BRANDING AND<br> IDENTITY</h3>
                            <p class="uk-text-justify uk-text-medium" style="color: snow;word-spacing: 1px;letter-spacing: -1px">WebSoulLabs is one of the most reliable branding company that helps you to build amazing brand identities and create a great impact on your target audience. We provide unique and creative solutions for your brand.</p>
                       
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <br>  

    <div class="uk-container">
        
        <h2 class="uk-text-center uk-text-uppercase" style="margin-bottom: 0px; font-weight: 600px;"><span>What sets us apart? </span></h2>
        <blockquote>
            <p class="uk-margin-small-bottom uk-text-center">“Mutual growth is what makes the World growing in all fields. We believe  in flourishing together with our customers.”</p>
            <footer class="uk-text-center" style="font-size:18px">Websoul team </footer>
        </blockquote>   
        <div class="uk-container">
            <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center " uk-grid>
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                    
                        <img class="uk-align-center" src="../../assets/trust.png" width="50" height="50" alt="">
                        <h4 class="uk-text-center" style="padding-top: 0px; margin-top: 0px; font-weight: 600;">HONESTY AND FAIRNESS
                        </h4>
                        <p class="uk-text-justify uk-text-medium" style="word-spacing: -1px;letter-spacing: -1px">No relationships can be maintained without honesty  and fairness. We always thrive to maintain our beautiful and healthy relationships with all our customers. Our success relies in retaining good relationships with clients.

                        </p>
                    </div>
                </div>
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                    
                        <img class="uk-align-center" src="../../assets/respect.png" width="50" height="50" alt="">
                        <h4 class="uk-text-center" style="padding-top: 0px; margin-top: 0px;  font-weight: 600;">HUMBLENESS AND HUMILITY</h4>
                        <p class="uk-text-justify uk-text-medium" style="word-spacing: -1px;letter-spacing: -1px">At WebSoulLabs, we have the humble workplace culture take-up the honesty, experimentation and always learning new lessons that leads to success. We are curious and embrace to learn new things. We also prioritize development.</p>
                    </div>
                </div>
            

                <div>
            
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                        <img class="uk-align-center" src="../../assets/growth.png" width="50" height="50" alt="">
                        <h4 class="uk-text-center" style="padding-top: 0px; margin-top: 0px;  font-weight: 600;">HARD WORK AND SUCCESS</h4>
                        <p class="uk-text-justify uk-text-medium" style="word-spacing: 1px;letter-spacing: -1px">No success can be achieved without hard work. Success is nothing but a long journey of dedication and hard work. We always work hard until we touch the kind of success we want. It’s all about hard work matters. Nothing comes easily.</p>
                
                    </div>
                </div>


                <div>
            
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                        <img class="uk-align-center" src="../../assets/success.png"  style="margin-bottom: 25px;" width="50" height="50"
                            alt="">
                        <h4 class="uk-text-center" style="padding-top: 0px; margin-top: 0px; font-weight: 600;">PURSUIT OF EXCELLENCE</h4>
                        <p class="uk-text-justify uk-text-medium" style="word-spacing: 1px;letter-spacing: -1px">At WebSoulLabs, we always do our best in whatever we do. We are not fearful of change or challenges but will make things happen even with barriers. The key is not to worry about being  the successfull, work hard toward being significant.</p>
                
                    </div>
                </div>

                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                        <img class=" uk-align-center" src="../../assets/customer.png" width="85" height="85" style="margin-bottom: 15px;" alt="">
                        <h4 class="uk-text-center" style="padding-top: 0px; margin-top: 0px;  font-weight: 600;">CUSTOMER ORIENTED</h4>
                        <p class="uk-text-justify uk-text-medium" style="word-spacing: -2px;letter-spacing: -1px">We always focus on helping our customers to meet their long term needs. We focus directly  on solving for the customer and makes them satisfy. All the projects undertake in terms of cost and values.</p>
                
                    </div>
                </div>

                <div>
            
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-top: 10px; padding-bottom: 10px;">
                        <img class="uk-align-center" src="../../assets/kno.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center" style="padding-top: 0px; margin-top: 0px;  font-weight: 600;">INNOVATIVE BUSINESS IDEAS
                        </h4>
                        <p class="uk-text-justify uk-text-medium" style="word-spacing: -2px;letter-spacing: -1px">Coming up with a unique and trending business idea takes confidence, patience. If you want to make them true, learn from us, think about the greatest solutions we have for your problem solutions.</p>
                
                    </div>
                </div>

                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-top: 30px; padding-bottom: 10px;">
                        <img class="uk-align-center" src="../../assets/hu.png" width="80" height="80" alt="">
                        <h4 class="uk-text-center" style="padding-top: 0px; margin-top: 0px;  font-weight: 600;">EFFECTIVE TEAMWORK
                        </h4>
                        <p class="uk-text-justify uk-text-medium" style="word-spacing: -2px;letter-spacing: -1px">It is the major aspect of our organization is success. We always believe in our team, and they do the same also. Your goals become our goals. We work as a team and handle all our clients judiciously.</p>
                
                    </div>
                </div>

            </div>
        </div>
    </div>
    
    
    


